/**
 * @desc 将加载组件放到Vue.prototype上
 */

import Vue from 'vue'
import Spinner from './Spinner.vue'

const SpinnerConstructor = Vue.extend(Spinner)
// 实例化spinner
let instance

// 单例模式
function showSpinner (msg) {
  if (!instance) {
    instance = new SpinnerConstructor({
      el: document.createElement('div')
    })
  }
  if (instance.show) return
  instance.msg = msg
  // 添加到body上
  // document.body.appendChild(instance.$el)
  var node = document.body.firstChild;
  if (node) {
    node.parentNode.insertBefore(instance.$el, node);
  } else {
    document.body.appendChild(instance.$el);
  }
  Vue.nextTick(() => {
    instance.show = true
  })
}

// 销毁
const closeSpinner = () => {
  instance.show = false
}

// 注册到全局组件
Vue.prototype.$spinner = {
  open: showSpinner,
  close: closeSpinner
}
